import { StyledSpinner } from './StyledComponents';

import '../styles/Loading.css';

const Loading = () => {

  return (
    <div className="spinnerContainer" >
      <StyledSpinner></StyledSpinner>
    </div>
  )
};

export default Loading